"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackgroundColorForVariants = void 0;
var _constants = require("./constants");
const getBackgroundColorForVariants = (url, backgroundColor) => {
  if (typeof backgroundColor === 'undefined') {
    return url.searchParams.get(_constants.IMAGE_BACKGROUND_PARAM);
  }
  return backgroundColor;
};
exports.getBackgroundColorForVariants = getBackgroundColorForVariants;
